<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="editCustomSLADialog" persistent max-width="850">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text"
          >Update Custom Deadline</v-card-title
          >
          <v-card-text>
            <v-container grid-list-xl fluid>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs4>
                    <v-select style="margin-top: 10px"
                              label="Sale Number"
                              item-text="name"
                              item-value="value"
                              v-model="edit_sale_num"
                              :items="editSaleNumbers"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-select style="margin-top: 10px"
                              label="Season"
                              item-text="name"
                              item-value="value"
                              v-model="edit_season"
                              :items="saleSeasons"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Org Code"
                      min="1"
                      type="text"
                      v-model="edit_org_code"
                      :error-messages="orgCodeErrorMessages"
                      @input="validateOrgCodeUpdate"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-select style="margin-top: 10px"
                              label="File Type"
                              item-text="name"
                              item-value="value"
                              v-model="edit_file_type"
                              :items="fileTypes"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-select style="margin-top: 10px"
                              label="Org Type"
                              item-text="name"
                              item-value="value"
                              v-model="edit_org_type"
                              :items="organisationTypes"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Duration (Hours)"
                      min="1"
                      type="number"
                      v-model="edit_duration"
                      :error-messages="durationErrorMessages"
                      @input="validateDurationUpdate"
                    ></v-text-field>
                  </v-flex>

                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="white"
              class="accentd&#45;&#45;text"
              style="font-weight: 700"
              @click="editCustomSLADialog = false"
            >Cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="updateCustomDeadline"
            >Submit</v-btn
            >
            <v-progress-circular
              style="margin-left: 10px"
              v-show="edit_loader"
              color="red"
              size="20"
              indeterminate
            ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="approveRejectCustomSlaDialog" persistent max-width="500">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Custom SLA</v-card-title>
          <v-card-text v-if="approveStatus === 1">Do you want to approve the SLA? </v-card-text>
          <v-card-text v-if="approveStatus === 0">Do you want to reject the SLA? </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="approveRejectCustomSlaDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="approveStatus === 1" color="secondary"  @click="approveCustomSLA">Approve</v-btn>
            <v-btn v-if="approveStatus === 0" color="secondary"  @click="approveCustomSLA">Reject</v-btn>
            <v-progress-circular
              style="margin-left: 10px"
              v-show="approve_loader"
              color="red"
              size="20"
              indeterminate
            ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Custom SLA </span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
            </v-layout>
            <v-container grid-list-xl fluid v-if="canCreateTimeline">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs3>
                    <v-select style="margin-top: 10px"
                              label="Sale Number"
                              item-text="name"
                              item-value="value"
                              v-model="sale_number"
                              :items="saleNumbers"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs3>
                    <v-select style="margin-top: 10px"
                              label="Sale Season"
                              item-text="name"
                              item-value="value"
                              v-model="season_sale"
                              :items="saleSeasons"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs3>
                    <v-select style="margin-top: 10px"
                              label="Org Type"
                              item-text="name"
                              item-value="value"
                              v-model="org_type"
                              :items="organisationTypes"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      label="Org Code"
                      min="1"
                      type="text"
                      v-model="org_code"
                      :error-messages="orgCodeErrorMessages"
                      @input="validateOrgCode"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select style="margin-top: 10px"
                              label="File Type"
                              item-text="name"
                              item-value="value"
                              v-model="file_type"
                              :items="fileTypes"
                              variant="solo-filled"
                              solo
                              hide-details
                              return-object
                              dense
                    ></v-select>
                  </v-flex>

                  <v-flex xs3>
                    <v-text-field
                      label="Duration (Hours)"
                      min="1"
                      type="number"
                      v-model="duration"
                      :error-messages="durationErrorMessages"
                      @input="validateDuration"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-btn color="#7BC243" @click="submitCustomDeadline()" class="white--text cataloguebtn">Submit </v-btn>
                    <v-progress-circular
                      style="margin-left: 10px"
                      v-show="create_loader"
                      color="red"
                      size="20"
                      indeterminate
                    ></v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
            <br/>
            <v-data-table
              :headers="headers"
              :items="saleDates"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
<!--                <v-btn
                  class="btn"
                  @click="editSweepingCharge(item)"
                  color="primary">
                  Edit
                </v-btn>-->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      
                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="item['status']['statusName'] !== 'REJECTED' && item['status']['statusName'] !== 'DISABLED'">
<!--                  <v-list v-if="canCreateTimeline || canUpdateTimeline">-->
<!--                  <v-list v-if="canCreateTimeline && item['status']['statusName'] === 'PENDINGAPPROVAL'">-->
                    <v-list-item v-if="canCreateTimeline && item['createdByOrgType']['name'] === organisationType">
                      <v-list-item-title style="cursor: pointer" @click="editDefaultDeadline(item)"> Edit </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canUpdateTimeline && item['createdByOrgType']['name'] === organisationType && item['status']['statusName'] === 'PENDING_APPROVAL'">
                      <v-list-item-title style="cursor: pointer" @click="approveRejectCustomSlaShowDialog(item, 1)">Approve</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canUpdateTimeline && item['createdByOrgType']['name'] === organisationType && item['status']['statusName'] === 'PENDING_APPROVAL'" >
                      <v-list-item-title style="cursor: pointer" @click="approveRejectCustomSlaShowDialog(item, 0)"> Reject </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'
import warehouse from '@/components/views/charge/warehouse.vue'
import Datepicker from 'vuejs-datepicker'
export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			editCustomSLADialog: false,
			saleDates: [],
			create_loader: false,
			edit_loader: false,
			approve_loader: false,
			approveRejectCustomSlaDialog: false,
			approveStatus: 0,
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			org_type: '',
			sale_number: '',
			season_sale: '',
			org_code: '',
			edit_org_code: '',
			duration: '',
			file_type: '',
			edit_file_type: '',
			edit_org_type: '',
			default_deadline_id: 0,
			edit_duration: '',
			fileTypes: [],
			organisationTypes: [],
			sale_start_date: '',
			sale_start_date_min: '',
			sale_start_date_max: '',
			sale_end_date_min: '',
			sale_interval: '',
			sale_end_date: '',
			sale_season: '',
			edit_sale_number: '',
			edit_sale_num: '',
			edit_interval: '',
			edit_season: '',
			edit_start_date: null,
			edit_end_date: null,
			currentYear: new Date(),
			orgCodeErrorMessages: [],
			startDateErrorMessages: [],
			durationErrorMessages: [],
			endDateErrorMessages: [],
			seasonErrorMessages: [],
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Sale #', value: 'saleNumber' },
				{ text: 'Season', value: 'season' },
				{ text: 'File Type', value: 'fileType.fileName' },
				{ text: 'Org Type', value: 'organisationType.name' },
				{ text: 'Org Code', value: 'organisation.organisationCode' },
				{ text: 'Duration', value: 'fileDuration' },
				{ text: 'Status', value: 'status.statusName' },
				{ text: 'Approval Date', value: 'approvalTime' },
				{ text: 'Last Date', value: 'lastDateTime' },
				{ text: 'Actions', value: 'actions', sortable: false }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			custom_deadline_id: 0,
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null,
			sale: '',
			sales: [],
			season: '',
			seasons: [],
			saleNumbers: [],
			editSaleNumbers: [],
			saleSeasons: []
		}
	},
	mounted () {
		// this.getWarehouseReport()
		this.getSeasons()
		this.getCustomDeadlines()
		this.initDefaultSLA()
		this.getSaleDates()
		this.permissions = store.state.user.roleId.permissions
		const month = ('0' + (this.currentYear.getMonth() + 1)).slice(-2)
		const day = ('0' + this.currentYear.getDate()).slice(-2)
		this.sale_start_date_min = this.currentYear.getFullYear() + '-' + month + '-' + day
		this.sale_start_date_max = this.currentYear.getFullYear() + '-10-01'
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canCreateTimeline: function () {
			return this.hasPerm('CAN_CREATE_TIMELINE')
		},
		canUpdateTimeline: function () {
			return this.hasPerm('CAN_UPDATE_TIMELINE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				console.log('organisationType - ', this.organisationType)
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		editDefaultDeadline (item) {
			console.log('-->!!!! ', item)
			console.log('-->!!!!== ', item.organisation.organisationCode)
			this.editCustomSLADialog = true
			this.default_deadline_id = item.id
      this.editSaleNumbers.push(item.saleNumber)
			this.edit_sale_num = item.saleNumber
			this.edit_season = item.season
			console.log('444== ', this.edit_sale_num)
			console.log('333-- ', this.edit_season)
			console.log('333555-- ', this.editSaleNumbers)
			this.edit_org_type = item.organisationType.name
			this.edit_org_code = item.organisation.organisationCode
			this.edit_file_type = item.fileType.fileName
			this.edit_duration = item.fileDuration
		},
		approveRejectCustomSlaShowDialog (item, status) {
			console.log(item)
			console.log(status)
			this.approveStatus = status
			this.custom_deadline_id = item.id
			this.approveRejectCustomSlaDialog = true
		},
		approveCustomSLA () {
			this.approve_loader = true
			var url = config.serverURI + '/saledate/approveCustomDeadline?id=' + this.custom_deadline_id + '&status=' + this.approveStatus
			axios
				.put(url, {})
			    .then(response => {
					this.approve_loader = false
					const message = response.data.body.message
					console.log('timer44---', message)
					this.create_loader = false
					this.approveRejectCustomSlaDialog = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.org_type = ''
						this.org_code = ''
						this.duration = ''
						this.file_type = ''

						let msg = 'Successfully approved custom deadline'
						if (this.approveStatus === 0) {
							msg = 'Successfully rejected custom deadline'
						}

						this.initDefaultSLA()
						this.getCustomDeadlines()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = msg

						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.approve_loader = false
					this.approveRejectCustomSlaDialog = false
					this.message = 'Something went wrong, please try again'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		initDefaultSLA () {
			console.log('sales10133 => ')
			http.get(config.serverURI + '/saledate/defaultSlaFindAll')
				.then(response => {
					console.log('sales101 => ', response.data)
					// this.fileTypes = response.data.fileTypes
					response.data.organisationTypes.forEach(x => {
						console.log('sa => ', x)
						this.organisationTypes.push(x.name)
					})

					response.data.fileTypes.forEach(x => {
						console.log('sa => ', x)
						this.fileTypes.push(x.fileName)
					})
					// this.salesStatements = response.data
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSaleDates () {
			console.log('sales10133 => ')
			http.get(config.serverURI + '/saledate/findNextSaleDate')
				.then(response => {
					console.log('sales101findAll => ', response.data)
					// response.data.forEach(x => {
					// 	this.saleNumbers.push(x.saleNumber)
					// 	this.saleSeasons.push(x.season)
					// })
					const status = response.data.status.statusName
					console.log('status => ', status)
					if (status.toString().toUpperCase() === 'APPROVED') {
						this.saleNumbers.push(response.data.saleNumber)
						this.saleSeasons.push(response.data.season)
					}
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSeasons () {
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},
		getCustomDeadlines () {
			http.get(config.serverURI + '/saledate/customDeadlineFindAll')
				.then(response => {
					console.log('sales101 => ', response.data)
					this.saleDates = response.data
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		updateCustomDeadline () {
			console.log('durt = ', this.edit_duration)
			if (this.edit_duration < 1 || this.edit_duration > 1) {
				this.durationErrorMessages.push('The duration should not be less or more than 1 hour')
				return
			}
			this.edit_loader = true
			const url = config.serverURI + '/saledate/editCustomSLA?id=' + this.default_deadline_id + '&orgCode=' + this.edit_org_code + '&fileType=' + this.edit_file_type + '&orgType=' + this.edit_org_type + '&duration=' + this.edit_duration + '&saleNumber=' + this.edit_sale_num + '&season=' + this.edit_season
			axios.put(url)
				.then(response => {
					this.edit_loader = false
					console.log('timer4453333', response)
					const message = response.data.body.message
					console.log('timer44', message)
					this.create_loader = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.org_type = ''
						this.duration = ''
						this.edit_duration = ''
						this.edit_file_type = ''
						this.edit_org_type = ''
						this.editCustomSLADialog = false
						this.initDefaultSLA()
						this.getCustomDeadlines()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully edited custom deadline'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.edit_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
		submitCustomDeadline () {
			if (this.duration < 1 || this.duration > 1) {
				this.durationErrorMessages.push('The duration should not be less or more than 1 hour')
				return
			} if (this.org_type.toUpperCase() === 'MILLER' && this.org_code.length !== 2) {
				return
			} else if (this.org_type.toUpperCase() === 'BROKER' && this.org_code.length !== 2) {
				return
			} else if (this.org_type.toUpperCase() === 'WAREHOUSE' && this.org_code.length > 7) {
				return
			} else if (this.sale_number === '' || this.season_sale === '') {
				this.snackbar = true
				this.snackbarColor = 'error'
				this.message = 'Please enter sale number/season'
				return
			}
			console.log('this.sale')
			this.create_loader = true
			console.log('filetype - ', this.file_type)
			console.log('orgtype - ', this.org_type)
			const url = config.serverURI + '/saledate/saveCustomSLA?orgCode=' + this.org_code + '&fileType=' + this.file_type + '&orgType=' + this.org_type + '&duration=' + this.duration + '&saleNumber=' + this.sale_number + '&season=' + this.season_sale
			axios.post(url)
				.then(response => {
					console.log('timer445', response)
					const message = response.data.body.message
					console.log('timer44---', message)
					this.create_loader = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.org_type = ''
						this.org_code = ''
						this.duration = ''
						this.file_type = ''

						this.initDefaultSLA()
						this.getCustomDeadlines()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully added custom deadline'

						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.create_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
		validateDuration () {
			const interval = parseInt(this.duration)
			if (isNaN(interval) || interval < 1 || interval > 1) {
				this.durationErrorMessages = [
					'The duration should not be less or more than 1 hour'
				]
			} else {
				this.durationErrorMessages = []
			}
		},
		validateDurationUpdate () {
			const interval = parseInt(this.edit_duration)
			if (isNaN(interval) || interval < 1 || interval > 1) {
				this.durationErrorMessages = [
					'The duration should not be less or more than 1 hour'
				]
			} else {
				this.durationErrorMessages = []
			}
		},
		validateOrgCode () {
			const orgType = this.org_type
			const orgCode = this.org_code
			console.log('orgType ', orgType)
			console.log('orgCode ', orgCode)
			if (orgType.toUpperCase() === 'MILLER' && orgCode.length !== 2) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for miller']
			} else if (orgType.toUpperCase() === 'BROKER' && orgCode.length !== 2) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for broker']
			} else if (orgType.toUpperCase() === 'WAREHOUSE' && orgCode.length > 7) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for warehouse']
			} else {
				this.orgCodeErrorMessages = []
			}
		},
		validateOrgCodeUpdate () {
			const orgType = this.edit_org_type
			const orgCode = this.edit_org_code
			console.log('orgType ', orgType)
			console.log('orgCode ', orgCode)
			if (orgType.toUpperCase() === 'MILLER' && orgCode.length !== 2) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for miller']
			} else if (orgType.toUpperCase() === 'BROKER' && orgCode.length !== 2) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for broker']
			} else if (orgType.toUpperCase() === 'WAREHOUSE' && orgCode.length > 7) {
				this.orgCodeErrorMessages = ['Please enter a valid org code for warehouse']
			} else {
				this.orgCodeErrorMessages = []
			}
		},
		formatDate (timestamp) {
			const date = new Date(timestamp)
			return date.toLocaleDateString() // Formats date to a string in mm/dd/yyyy format
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
